import alasql from "alasql";
import React, { useEffect, useState } from "react";

import { Admin, buildI18nProvider } from '@react-admin/ra-enterprise';
import { ContainerLayout,Breadcrumb,HorizontalMenu } from '@react-admin/ra-navigation';
import { AppBar, Resource, TitlePortal } from "react-admin";
import MultiLevelMenuWithCategories from './core/layout/Menu';

import { createHttpLink, ApolloClient, InMemoryCache } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import { setContext } from "@apollo/client/link/context";
import { jwtDecode } from 'jwt-decode';
import PostIcon from "@mui/icons-material/Book";
import CircularProgress from "@mui/material/CircularProgress";
import { AppLocationContext } from "@react-admin/ra-navigation";
import {
  Layout
} from 'react-admin';
import "./App.css";
import authProvider from "./authProvider";
import { generateIframeRoutes, loadAllTablesFromAirtable, tablesToLoad } from "./config";
import "./core/assets/css/custom.css";
import ResourceCreate from "./core/resource/Create";
import ResourceEdit from "./core/resource/Edit";
import ResourceList from "./core/resource/List";
import ResourceShow from "./core/resource/Show";
import { getMessages } from "./core/utils/lang";
import Login from "./login";
import buildUploadDataProvider from './uploadDataProvider';

import { radiantLightTheme } from "./core/layout/themev2";
//import { addEventsForMutations } from "@react-admin/ra-audit-log";

import { IconButton } from '@mui/material';
import { LoadingIndicator } from 'react-admin';

import ReportIcon from '@mui/icons-material/Assessment'; // You can choose a different icon if preferred
import Tooltip from '@mui/material/Tooltip';

import NotificationsButton from './NotificationsButton';

import Header from './Header'; // Import your custom menu


import { LocalizationProvider } from "@mui/x-date-pickers";
import { wrapDataProviderWithGlobalErrorHandler } from "./globalErrorHandler";

import Dashboard from './dashboard/Dashboard';
import { Typography } from '@mui/material';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { arSD } from '@mui/material/locale';



const DashboardButton = () => (
  <Tooltip title="مؤشرات ألامن والسلامة" arrow>
    <IconButton
      color="inherit"
      onClick={() => window.open(`https://aman-dashboard-staging.rafed.cloud/BI/aman?token=${window.localStorage.getItem("hz-tokenLogin")}`, '_blank')}
    >
      <ReportIcon />
    </IconButton>
  </Tooltip>
);


const ReportsButton = () => (
  <Tooltip title="تقارير النظام" arrow>
    <IconButton
      color="inherit"
      onClick={() => window.open(`https://reports-api.tatweertransit.com/Aman?token=${window.localStorage.getItem("tokenLogin")}`, '_blank')}
    >
      <ReportIcon />
    </IconButton>
  </Tooltip>
);


window.alasql = alasql;

const httpLink = createHttpLink({
  uri: import.meta.env.REACT_APP_GRAPHQL_HTTP_URI,
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      authorization: "Bearer " + localStorage.getItem("hz-tokenLogin"),
    },
  };
});


export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});




const MyAppBar = () => (
  <AppBar>
    <TitlePortal />
  </AppBar>
);



const MLayout = ({ children, release }) => {
  // 1. Define the toolbar here, so it can use 'release'
  const toolbar = (
    <>
    <ReportsButton />
    <DashboardButton />

<NotificationsButton />
<LoadingIndicator />

      {/* Example usage of release */}
      {release && (
        <Typography variant="body2" sx={{ color: '#fff', marginLeft: 2 }}>
          الإصدار {release}
        </Typography>
      )}
    </>
  );
  //appBar={<Header />}

  

  // 2. Pass that 'toolbar' to ContainerLayout
  return (
    <AppLocationContext>
      <ContainerLayout maxWidth={false} appBar={<Header />}  toolbar={toolbar}>
      <Breadcrumb />

        {children}
      </ContainerLayout>
    </AppLocationContext>
  );
};

const languages = [
  { locale: "en", name: "English" },
  { locale: "ar", name: "عربي" },
];

// Helper to safely get role only if token is valid
const getValidRole = () => {
  const token = localStorage.getItem('tokenLogin');
  const role = localStorage.getItem('role');
  
  if (!token || !role) {
    return 'none';
  }
  
  try {
    const decodedToken = jwtDecode(token);
    // Check if token is expired
    if (decodedToken.exp * 1000 < Date.now()) {
      // Token expired - don't use this role
      return 'none';
    }
    return role;
  } catch (error) {
    // Invalid token
    return 'none';
  }
};

function App() {
  const [loading, setLoading] = useState(true);
  const [resources, setResources] = useState(null);
  const [release, setRelease] = useState(null);
  const [resource_names, setResourceNames] = useState(null);
  const [role, setRole] = useState(getValidRole());
  const [resourcePermistions, setResourcePermistions] = useState([]);
  const [customRoutes, setCustomRoutes] = useState([]);
  // Stub dataProvider used before real one loads (requireAuth redirects to login first)
  const stubDataProvider = {
    getList: () => Promise.resolve({ data: [], total: 0 }),
    getOne: () => Promise.resolve({ data: {} }),
    getMany: () => Promise.resolve({ data: [] }),
    getManyReference: () => Promise.resolve({ data: [], total: 0 }),
    create: () => Promise.resolve({ data: {} }),
    update: () => Promise.resolve({ data: {} }),
    updateMany: () => Promise.resolve({ data: [] }),
    delete: () => Promise.resolve({ data: {} }),
    deleteMany: () => Promise.resolve({ data: [] }),
  };
  const [dataProvider, setDataProvider] = useState(null);

  useEffect(() => {

    const fetchData = async () => {
      let loadedData = {};
      let resourcePermistionsTable = [];

      try {
        console.log("Loading data from Airtable...");
        loadedData = await loadAllTablesFromAirtable();
        console.log("Data loaded successfully:", Object.keys(loadedData));
        resourcePermistionsTable = loadedData['resource_permistions'] || [];
      } catch (error) {
        console.error("Error loading data from Airtable:", error);
        // Set default empty data to prevent crashes
        loadedData = {};
        resourcePermistionsTable = [];
        // You might want to show a user-friendly error message here
        return; // Exit early if data loading fails
      }

      let acls = localStorage.getItem("acls")
        ? JSON.parse(localStorage.getItem("acls"))
        : {};

      /*       const aclPermistions = resourcePermistionsTable
              .reduce((stats, row) => {
                 if (acls[row.resource_name]) {
                  let acl = acls[row.resource_name];
                  row.admin_add = acl.add;
                  row.admin_edit = acl.edit;
                  row.admin_delete = acl.delete;
                  row.admin_show = acl.show;
                  row.admin_list = acl.show;
                }
      
                stats.modifed.push(row); 
                return stats;
              }, {
                modifed: [],
              });
       */


      for (const tableConfig of tablesToLoad) {
        const { tableName, alasqlTableName } = tableConfig;

        try {
          // Check if data exists for this table
          if (!loadedData[tableName]) {
            console.warn(`No data found for table: ${tableName}`);
            continue;
          }

          if (!Array.isArray(loadedData[tableName]) || loadedData[tableName].length === 0) {
            console.warn(`No data rows for table: ${tableName}`);
            continue;
          }

          // Drop existing table if it exists
          alasql(`DROP TABLE IF EXISTS ${alasqlTableName}`);
          
          // Create the table and insert data in one step
          alasql(`CREATE TABLE ${alasqlTableName}`);
          alasql(`INSERT INTO ${alasqlTableName} SELECT * FROM ?`, [loadedData[tableName]]);
          
          console.log(`Successfully loaded table: ${alasqlTableName} with ${loadedData[tableName].length} rows`);
        } catch (error) {
          console.error(`Error loading table ${alasqlTableName}:`, error);
          // Continue with other tables even if one fails
        }
      }

      let admin_data = [];
      let version = null;
      
      try {
        // Check if admin table exists and has data before querying
        const adminExists = alasql.databases.alasql && 
                           alasql.databases.alasql.tables && 
                           alasql.databases.alasql.tables.admin && 
                           alasql.databases.alasql.tables.admin.data;
        
        if (adminExists) {
          admin_data = alasql("select * from admin");
          const versionObj = admin_data.find((setting) => setting.name === 'version');
          // If found, extract its value
          version = versionObj ? versionObj.value : null;
        } else {
          console.warn("Admin table not found or empty, using default values");
        }
      } catch (error) {
        console.error("Error accessing admin table:", error);
        admin_data = [];
        version = null;
      }
      
      setRelease(import.meta.env.REACT_APP_VERSION);





      const propertiesToSet = [
        { name: "UPLOAD_SERVER_ENDPOINT", localStorageKey: "UPLOAD_SERVER_ENDPOINT" },
        { name: "DOWNLOAD_SERVER_ENDPOINT", localStorageKey: "DOWNLOAD_SERVER_ENDPOINT" },
        { name: "MAPBOX_ACCESS_TOKEN", localStorageKey: "MAPBOX_ACCESS_TOKEN" },
        { name: "COLOR", localStorageKey: "COLOR", defaultValue: "purple" },
        { name: "TITLE", localStorageKey: "TITLE", propertyName: "TITLE" },
        { name: "DIRECTION", localStorageKey: "DIRECTION", propertyName: "DIRECTION" },
      ];

      for (const property of propertiesToSet) {
        //  setProperty(this, admin_data, property);
      }


      const updateDataProvider = async () => {
        const withUploadDataProvider = await buildUploadDataProvider();



        /*      const dataProviderLogs = addEventsForMutations(
               dataProviderWithSearch,
               authProvider
             ); */
        setDataProvider(wrapDataProviderWithGlobalErrorHandler(withUploadDataProvider));

      };

      // Call the function to update the data provider and log the data.
      await updateDataProvider();


      let resources = alasql("select * from resources");
      let resource_names = role === 'none' ? [] : alasql(
        `select distinct resource_name from resources where resource_name <> '' AND ( role_${role}='read' OR role_${role}='write' ) `
      );
      let resourcePermistions = alasql(
        'select * from resource_permistions  where resource_name <> "" '
      );

      //console.log(`role_${role} `);


      setResources(resources);
      setResourceNames(resource_names);
      setRole(role);
      setResourcePermistions(resourcePermistions);
      setLoading(false);

    };

    fetchData();
  }, [role]);


  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: 150 }}>
        <CircularProgress />
        <h2>جارِ التحميل</h2>
      </div>
    );
  }

  const localizationMessages = {
    ar: getMessages("ar"),
    // en: getMessages("en"),
  };

  const resourceComponents = (role === 'none' ? [] : resourcePermistions).filter((resourcePermition) => !resourcePermition.is_custom_tab)
    .map((resourcePermition, index) => {


      const permition = alasql(
        `SELECT distinct role_${role} as the_role FROM resources WHERE resource_name ='${resourcePermition.resource_name}' `
      ).map(({ the_role }) => the_role);

      const canEdit =
        resourcePermition[`${role}_edit`] == true &&
        resourcePermition[`inline_update`] == false;
      const canDelete = resourcePermition[`${role}_delete`] == true;
      const canList = resourcePermition[`${role}_list`] == true;
      const canShow = resourcePermition[`${role}_show`] == true;
      const canAdd =
        resourcePermition[`${role}_add`] == true &&
        resourcePermition[`inline_create`] == false;

      return (
        <Resource
          name={resourcePermition.resource_name}
          icon={PostIcon}
          list={canList && ResourceList}
          edit={canEdit && ResourceEdit}
          create={canAdd && ResourceCreate}
          show={canShow && ResourceShow}
          canDelete={canDelete}

          key={resourcePermition.resource_name} // Ensure a unique key
        />
      );
    });

    const rtlTheme = createTheme(
      {
        ...radiantLightTheme, // Your existing theme merged
        direction: 'rtl',
        typography: {
          fontFamily: 'inherit', // Optional: inherit fonts from your layout
        },
      },
      arSD // Arabic locale
    );
    
    

  return (
    <ApolloProvider client={apolloClient}>
      <ThemeProvider theme={rtlTheme}> {/* Crucial for MUI internal components */}
      <div style={{ direction: "rtl" }}>

          <Admin
            title={"منصة الأمن والسلامة  - رافد"}
            
            dashboard={Dashboard}

            i18nProvider={buildI18nProvider(localizationMessages, "ar", languages)}
            dataProvider={dataProvider ?? stubDataProvider}
            authProvider={authProvider}
            loginPage={Login}
            disableTelemetry
            layout={(props) => <MLayout {...props} release={release} />}
            lightTheme={rtlTheme}
            darkTheme={rtlTheme}
            defaultTheme="light"


            requireAuth
          >
            {generateIframeRoutes()}
            {resourceComponents}


          </Admin>

      </div>
      </ThemeProvider>
    </ApolloProvider>
  );
}

export default App;
